// Helper to get color based on file type (a palette name for Chip's `color`)
export const getFileTypeColor = (filetype = '') => {
  if (filetype.startsWith('image/')) return 'success';
  if (filetype === 'application/pdf') return 'error';
  if (filetype.startsWith('video/')) return 'secondary';
  if (filetype.startsWith('audio/')) return 'info';
  return 'default';
};

// The same colour as an `sx` color for icons. "default" has no palette entry, so
// those icons fall back to the secondary text colour instead of disappearing.
export const getFileIconColor = (filetype = '') => {
  const color = getFileTypeColor(filetype);
  return color === 'default' ? 'text.secondary' : `${color}.main`;
};
